export enum EmailIntent {
  InterviewRequest = 'interview_request',
  InterviewConfirmation = 'interview_confirmation',
  InterviewReschedule = 'interview_reschedule',
  InterviewCancellation = 'interview_cancellation',
  InterviewFeedback = 'interview_feedback',
  MatchStatusUpdate = 'match_status_update',
  DocumentRequest = 'document_request',
  Other = 'other',
  Admin = 'admin',
}

export const EMAIL_INTENT_REASONS = {
  [EmailIntent.InterviewRequest]: 'candidate or employer requesting to schedule an interview',
  [EmailIntent.InterviewConfirmation]: 'confirming a previously proposed interview slot',
  [EmailIntent.InterviewReschedule]: 'requesting to change an already confirmed interview',
  [EmailIntent.InterviewCancellation]: 'cancelling a confirmed interview',
  [EmailIntent.InterviewFeedback]: 'feedback on a conducted interview',
  [EmailIntent.MatchStatusUpdate]: 'enquiry or update on a candidate–employer match status',
  [EmailIntent.DocumentRequest]: 'requesting CVs, contracts, compliance docs, or other files',
  [EmailIntent.Other]: 'does not clearly map to the above — draft generated with reduced confidence indicator',
  [EmailIntent.Admin]: 'purely administrative (out-of-office, delivery receipt, internal forwarding with no content).',
};

export const EMAIL_INTENT_REASONS_I18N = {
  [EmailIntent.InterviewRequest]: 'Der Kandidat oder Arbeitgeber fordert an, ein Interview zu planen.',
  [EmailIntent.InterviewConfirmation]: 'Bestätigung eines zuvor vorgeschlagenen Interviewtermins.',
  [EmailIntent.InterviewReschedule]: 'Anfrage zur Änderung eines bereits bestätigten Interviews.',
  [EmailIntent.InterviewCancellation]: 'Absage eines bestätigten Interviews.',
  [EmailIntent.InterviewFeedback]: 'Feedback zu einem durchgeführten Interview.',
  [EmailIntent.MatchStatusUpdate]: 'Anfrage oder Aktualisierung zum Match-Status zwischen Kandidat und Arbeitgeber.',
  [EmailIntent.DocumentRequest]: 'Anforderung von Lebensläufen, Verträgen, Compliance-Dokumenten oder anderen Dateien.',
  [EmailIntent.Other]: 'Lässt sich nicht eindeutig zuordnen — Entwurf mit reduzierter Konfidenz erstellt.',
  [EmailIntent.Admin]: 'Reine Verwaltung (Abwesenheitsnotiz, Empfangsbestätigung, interne Weiterleitung ohne Inhalt).',
};

export const EMAIL_INTENT_DESCRIPTIONS: Record<EmailIntent, string[]> = {
  [EmailIntent.InterviewRequest]: [
    `The employer or candidate is proposing, requesting, or suggesting an interview.`,
    `Includes first-time scheduling attempts and open-ended invitations.`,
    `Example: "Wir würden den Kandidaten gerne kennenlernen."`,
  ],
  [EmailIntent.InterviewConfirmation]: [
    `All parties have agreed on a specific date, time, and format.`,
    `The email explicitly confirms a previously proposed slot.`,
    `Do NOT use if any detail (date, time, location) is still open.`,
  ],
  [EmailIntent.InterviewReschedule]: [
    `A previously confirmed interview is being moved to a new time.`,
    `Must involve an existing confirmed appointment — not just a counter-proposal during initial scheduling.`,
  ],
  [EmailIntent.InterviewCancellation]: [
    `A confirmed interview is being cancelled with no immediate replacement proposed.`,
    `If a new date is suggested in the same message, prefer interview_reschedule.`,
  ],
  [EmailIntent.InterviewFeedback]: [`Feedback on a conducted interview.`],
  [EmailIntent.MatchStatusUpdate]: [
    `The email conveys a decision or status change about the candidate's suitability or placement progress — e.g. rejection, approval, feedback after an interview, or a hiring decision.`,
  ],
  [EmailIntent.DocumentRequest]: [`The primary ask is for documents: CV, certificates, references, work permits, etc.`],
  [EmailIntent.Other]: [`Use only when none of the above clearly applies, but is not administrative.`],
  [EmailIntent.Admin]: [`If the email is purely administrative (out-of-office, delivery receipt, internal forwarding with no content).`],
};
